import type { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '../../../environments/environment';

export const authConfig: AuthConfig = {
  issuer: environment.auth.issuer,
  clientId: environment.auth.clientId,
  redirectUri: window.location.origin,
  responseType: 'code',
  scope: 'openid profile email',
  showDebugInformation: environment.auth.showDebugInformation,
  strictDiscoveryDocumentValidation: false,
  waitForTokenInMsec: 0,
  disableAtHashCheck: true,
};
